export enum StoreName {
  country = 'country',
  user = 'user',
  module = 'module',
  account = 'account'
}
